import { AUTHENTICATED, UNAUTHENTICATED, AUTHENTICATION_ERROR } from '../actions/UserActions';

export function UserReducer (state = {
  authenticated: false,
  data: {}
}, action) {
  switch (action.type) {
    case AUTHENTICATED:
    case 'USER_INFORMATION':
    case 'UPDATE_USER_INFORMATION':
      return { ...state, authenticated: true, data: { ...state.data, ...action.user }};
    case UNAUTHENTICATED:
      return { ...state, authenticated: false };
    case AUTHENTICATION_ERROR:
      return { ...state, error: action.payload };
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js